// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b9dbcc37","977":"2937a0e2"}[chunkId] + ".chunk.js";
};